// extracted by mini-css-extract-plugin
module.exports = {"style_a":"MainModal_style_a__9mX14","style_a1":"MainModal_style_a1__eqd4X","mouse_hover":"MainModal_mouse_hover__1Uf2u"};